module.exports["switch"] = "_switch_730248";
module.exports["sliderRound"] = "_sliderRound_730248";
module.exports["primary"] = "_primary_730248";
module.exports["secondary"] = "_secondary_730248";
module.exports["labelTitle"] = "_labelTitle_730248";